export default __webpack_public_path__ + "static/media/1194.646eb32e.png";